import type { BrandingDetailsType } from '@root/@types/types';
import dayjs from 'dayjs';

export const getAuthorship = (branding: Partial<BrandingDetailsType>) =>
  `Last updated ${dayjs(branding.updated_at ?? branding.created_at).fromNow()}${
    !!branding.last_updated_by && ` by ${branding.last_updated_by.name}`
  }`;
